import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Button } from "./ui/button";
import { getConsent, setConsent } from "../lib/consent";

export function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!getConsent());
  }, []);

  const choose = (value) => {
    setConsent(value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-4 sm:max-w-md z-[90] rounded-2xl border border-slate-200 bg-white shadow-2xl p-5"
      data-testid="cookie-consent-banner"
    >
      <div className="flex items-start gap-3 mb-4">
        <Cookie className="w-5 h-5 text-[#4F46E5] shrink-0 mt-0.5" />
        <p className="text-sm text-slate-600 leading-relaxed">
          We use first-party analytics to see which pages help people the most — no data is sold or shared with
          advertisers. See our{" "}
          <Link to="/privacy" className="text-[#4F46E5] font-medium hover:underline" data-testid="cookie-consent-privacy-link">
            Privacy Policy
          </Link>{" "}
          for details.
        </p>
      </div>
      <div className="flex items-center gap-2 justify-end">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => choose("declined")}
          data-testid="cookie-consent-decline-button"
          className="text-slate-500"
        >
          Opt out
        </Button>
        <Button
          size="sm"
          onClick={() => choose("accepted")}
          data-testid="cookie-consent-accept-button"
          className="text-white font-semibold"
          style={{ background: "#4F46E5" }}
        >
          Accept
        </Button>
      </div>
    </div>
  );
}
